import { FormField, FormProps } from '@studio/atomic-ui'
import { PortableTextProps } from '@portabletext/react/src'
import { useMemo } from 'react'

export const findField = (fields: FormField[], field: string): FormField | undefined => {
  let result

  const search = (fields: FormField[], field: string): boolean =>
    fields.some((f) => {
      if (f.type === 'grid' || f.type === 'conditional-checkbox') {
        return search(f.fields, field)
      }

      if (f.type === 'tab') {
        return f.tabs.some((t) => search(t.content, field))
      }

      const isWantedField = 'name' in f && f.name === field
      if (isWantedField) {
        result = f
      }
      return isWantedField
    })
  search(fields, field)

  return result
}

export const getErrorMessages = (
  fields: FormField[]
): {
  [key: string]: PortableTextProps['value']
} =>
  fields.reduce((acc, field) => {
    const checker = (field: FormField) =>
      'errorText' in field && field.errorText ? { ...acc, [field.name]: field.errorText } : acc

    if (field.type === 'grid' || field.type === 'conditional-checkbox') {
      return { ...acc, ...getErrorMessages(field.fields) }
    }

    if (field.type === 'tab') {
      return {
        ...acc,
        ...field.tabs.reduce<ReturnType<typeof checker>>(
          (acc, tab) => ({
            ...acc,
            ...getErrorMessages(tab.content),
          }),
          {}
        ),
      }
    }

    return checker(field)
  }, {})

/**
 *  Retrieve error messages from each field that have them
 * @param form - to get error messages from
 */
export const useErrorMessages = (
  form: Omit<FormProps, 'onChange' | 'onSubmit' | 'state' | 'onSecondaryClick'> | undefined
) =>
  useMemo(() => {
    if (!form) return
    return getErrorMessages(form?.fields)
  }, [form])

export const removePhoneMask = (phone?: string) => {
  if (!phone) return
  return phone.replace(/[() -]/g, '')
}
